<template>
  <v-btn
    v-bind="activatorProps"
    :icon="iconName"
    size="30"
    :text="title"
    class="ma-1"
    variant="outlined"
    @click="isActive = true"
  ></v-btn>
  <v-dialog max-width="900" v-model="isActive">
    <v-card :title="title">
      <v-sheet class="mx-auto" width="800">
        <SimpleDataTable
          :items="customerMeters"
          :headers="metersHeaders"
        ></SimpleDataTable>
      </v-sheet>

      <v-card-actions>
        <v-spacer></v-spacer>
        <DialogCustMetersAddRemove
          :v-model="dialogMetersAddRemove"
          iconName="mdi-plus"
          :customer="customer"
          :meters="availableMeters"
          mode="add"
        />
        <DialogCustMetersAddRemove
          :v-model="dialogMetersAddRemove"
          iconName="mdi-minus"
          :customer="customer"
          :meters="customerMeters"
          mode="remove"
        />
        <DialogCustMetersUpdate
          :v-model="dialogMetersUpdate"
          iconName="mdi-pencil"
          :customer="customer"
          :meters="customerMeters"
        />
        <!-- <v-btn text="حفظ" @click="save"></v-btn> -->
        <v-btn text="إغلاق" @click="close"></v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import DialogCustMetersAddRemove from "@/components/dialogs/DialogCustMetersAddRemove.vue";
import DialogCustMetersUpdate from "@/components/dialogs/DialogCustMetersUpdate.vue";
import SimpleDataTable from "@/components/common/SimpleDataTable.vue";
import repo from "@/store/repo.js";
export default {
  components: {
    DialogCustMetersAddRemove,
    DialogCustMetersUpdate,
    SimpleDataTable,
  },
  props: ["customer", "meters", "iconName"],
  data() {
    return {
      dialogMetersAddRemove: false,
      dialogMetersUpdate: false,
      isActive: false,
      metersHeaders: [
        { title: "الاسم", key: "name" },
        { title: "الرقم", key: "code" },
        // { title: "الحالة", key: "status" },
        { title: "تاريخ الإضافة", key: "pivot.added_at" },
        { title: "القراءة الأولية", key: "pivot.initial_reading" },
        // { title: "العداد الأب", key: "parent_id" },
      ],
    };
  },
  methods: {
    close() {
      this.isActive = false;
    },
  },
  watch: {
    isActive(value) {
      if (value) {
        //console.log(value);
      }
    },
  },
  computed: {
    customerMeters() {
      const cg = repo.customers.getCustomerMeters(this.customer.id);
      console.log("cg", cg);
      return cg;
    },
    availableMeters() {
      let x = this.meters.filter((g) => {
        return !this.customer.meters.map((x) => x.id).includes(g.id);
      });
      let y = this.customer.meters.filter((x) => x.deleted_at == null);
      return [...x, ...y];
    },
  },
};
</script>
